const C = {
  name: "Plugins",
  dimensions: { width: 19, height: 20 },
  content: `
    <svg fill="currentColor">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 0C12.5523 0 13 0.447715 13 1V3H15V1C15 0.447715 15.4477 0 16 0C16.5523 0 17 0.447715 17 1V3H18C18.5523 3 19 3.44772 19 4V8C19 10.419 17.2822 12.4367 15 12.9V15C15 17.7614 12.7614 20 10 20C7.23858 20 5 17.7614 5 15V9.5C5 8.67157 4.32843 8 3.5 8C2.67157 8 2 8.67157 2 9.5L2 14C2 14.5523 1.55228 15 1 15C0.447715 15 0 14.5523 0 14V9.5C0 7.567 1.56701 6 3.5 6C5.433 6 7 7.567 7 9.5V15C7 16.6569 8.34315 18 10 18C11.6569 18 13 16.6569 13 15V12.9C10.7178 12.4367 9 10.419 9 8V4C9 3.44772 9.44772 3 10 3H11V1C11 0.447715 11.4477 0 12 0ZM11 5V8C11 9.65685 12.3431 11 14 11C15.6569 11 17 9.65685 17 8V5H11Z" />
    </svg>

  `
};
export {
  C as Plugins
};
